// extracted by mini-css-extract-plugin
export default {"root":"App_root__ZeVwS","navigation":"App_navigation__C4i7E","container":"App_container__yqiFM"};